<template>
  <div class="main">
    <div class="search">
      <a @click="returnHome" class="return">
      </a>
      <input v-model="keyword" type="text" placeholder="小说书名或作者"/>
      <button type="button" class="search-btn" @click="searchBook">搜小说</button>
    </div>

    <div v-if="searched === false" class="mt25">
      <div class="hot-search">
        <h3>热门小说搜索</h3>
        <ul>
          <li v-for="(item, index) in hotWords" :key="index" @click="quickSearch(item)">{{item}}</li>
        </ul>
      </div>
      <div class="hot-search">
        <h3>搜索历史<a href="#"></a></h3>
        <ul>
          <li v-for="(item, index) in hisWords" :key="index" @click="quickSearch(item)">{{item}}</li>
        </ul>
      </div>
    </div>
    <books-large v-else style="padding-top: 2.5rem;" :books="books" :show-title="false"></books-large>
    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>
  </div>
</template>

<script>
  import BooksLarge from '../../../components/novel/books-large';
  import Alert from '../../../components/share/alert';

  import searchService from "../../../services/searchService";

  export default {
    name: "novel-search",
    data() {
      return {
        searched: false,
        alertMsg: '',
        showAlert: false,
        hotWords: '',
        hisWords: '',
        keyword: '',
        books: []
      }
    },
    methods: {
      returnHome() {
        this.$router.isBack = false;
        this.$router.push('/novel');
      },
      initSearch(){
        searchService.initSearch().then(res => {
          this.hotWords = res.data.hotWords[0].split("，");
        })
      },
      searchBook(){
        if (this.keyword === ''){
          this.alertMsg = "请输入搜索关键字";
          this.showAlert = true;
        }else if(this.keyword.length > 20){
          this.alertMsg = "搜索关键字最长不超过20个字";
          this.showAlert = true;
        }else {
          this.searched = true;
          this.hisWords = searchService.setHistorySearch(this.keyword);
          searchService.searchNovel(this.keyword).then(res => {
            if (res.data){
              this.books = res.data;
            }
          });
        }
      },
      quickSearch(content) {
        this.keyword = content;
        this.searchBook();
      }
    },
    components: {
      'books-large': BooksLarge,
      alert: Alert,
    },
    mounted() {
      this.initSearch();
      this.hisWords = searchService.getHistorySearch();
    }
  }
</script>

<style>
  @import '../../../assets/css/search.css';
</style>



// WEBPACK FOOTER //
// src/pages/layer2/novels/search.vue